import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../Wrapper/WrapperByRole'

const HeadSalesWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='headsales' {...props} />

export default HeadSalesWrapper